type ErrorProps = {
  id: string;
  message: string;
  title?: string;
};

export function FormFieldError({ id, message, title }: ErrorProps) {
  return (
    <div className="flex items-center justify-start gap-1 ps-1 text-red-700" id={id} role="alert">
      {title && <p className="font-bold text-xs">{title}:</p>}
      <p className="text-xs">{message}</p>
    </div>
  );
}
